// extracted by mini-css-extract-plugin
export default {"table":"sales-section_table__C-a7a","labelCell":"sales-section_labelCell__XUnON"};